// extracted by css-extract-rspack-plugin
export default {"merchantDevices":"src-domain-components-sync-configuration-merchant-modal-SyncConfigurationMerchantModal-module__merchantDevices-SPBgWo"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"merchantDevices\":\"src-domain-components-sync-configuration-merchant-modal-SyncConfigurationMerchantModal-module__merchantDevices-SPBgWo\"}";
        // 1793705032855
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  